import {Component, Inject} from '@angular/core';

import {UIDialogData} from 'app/ui/dialog/dialog-injector';
import {UIDialogService} from 'app/ui/dialog/dialog.service';
import {FeatureRequestSettings} from './feature-request.settings';
import {RequestConfirmationComponent} from './request-confirmation.component';

@Component({
    selector: 'feature-request',
    templateUrl: 'feature-request.component.html',
    styleUrls: ['feature-request.component.scss']
})
export class FeatureRequestComponent {

    request: string = null;

    constructor(
        @Inject(UIDialogData)
        public settings: FeatureRequestSettings,
        private _dialogService: UIDialogService) {
    }

    onSendRequest(): void {
        this._dialogService.open(RequestConfirmationComponent);
    }
}